import React from 'react'
import styled from 'styled-components'
import ProjectCard from './ProjectCard';
import { projects } from "./projectsContent";



function MyProjects() {
  return (
    <MyProjectsWrapper className='myprojects-wrapper'>
      {projects.map((project) => (
        <ProjectCard
          name={project.name}
          desc={project.desc}
          link={project.url}
          src={project.src}
        />
      ))}
      {/* <ProjectCard /> */}
      {/* <ProjectCard src={"./assets/images/projects/HA.jpg"} /> */}
    </MyProjectsWrapper>
  );
}

export default MyProjects

const MyProjectsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  width: 60%;
  margin: auto;
`;